import type { Locale } from '@/intl/types'
import type { GroupBookingData } from '@/scopes/account/group-responsible/domain/types'
import type {
  GroupBookingAPIResponse,
} from '@/scopes/account/group-responsible/infrastructure/types'
import { mapBuses } from './buses'
import { mapGroup } from './group'
import { mapParticipants } from './participants'
import { mapRooms } from './rooms'
import { getLabels } from './utils'

export function groupBookingMapper(apiResponse: GroupBookingAPIResponse, locale?: Locale): GroupBookingData {
  return {
    group: mapGroup(apiResponse.data, locale),
    labels: getLabels(apiResponse.data.startDate, apiResponse.data.endDate),
    participants: mapParticipants(apiResponse.data.childBookings),
    rooms: mapRooms(apiResponse.data.childBookings),
    buses: mapBuses(apiResponse.data.childBookings),
  }
}
